import { type EoReader, PacketAction, PacketFamily } from 'eolib';
import type { Client } from '@/client';
import { receiveWeaponStatus, registerWeaponStatusLifecycle } from '@/weapon-status';

export function registerCombatFeedbackHandlers(client: Client): void {
  registerWeaponStatusLifecycle(client);
  client.bus!.registerPacketHandler(54 as PacketFamily, PacketAction.Reply, (reader: EoReader) => {
    try {
      const hit = JSON.parse(reader.getString());
      if (hit?.kind === 'weapon_status') { receiveWeaponStatus(client, hit); return; }
      if (hit.map !== client.mapId || !Array.isArray(hit.elements) || !hit.elements.length || hit.damage <= 0) return;
      const bars = hit.kind === 'npc' ? client.animationController.npcHealthBars : hit.kind === 'player' ? client.animationController.characterHealthBars : null;
      const bar = bars?.get(hit.target);
      // Metadata belongs only to the immediately preceding authoritative damage result.
      if (bar && bar.damage === hit.damage && !bar.heal) bar.elemental = true;
    } catch { /* Ignore malformed optional feedback, never interrupt normal combat. */ }
  });
}
